import { render, staticRenderFns } from "./FinManIncome.vue?vue&type=template&id=0de84ab5&scoped=true"
import script from "./FinManIncome.vue?vue&type=script&lang=js"
export * from "./FinManIncome.vue?vue&type=script&lang=js"
import style0 from "./FinManIncome.vue?vue&type=style&index=0&id=0de84ab5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de84ab5",
  null
  
)

export default component.exports